import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, ButtonLink } from "../../../../components/Buttons";
import {
  W3Dropdown,
  W3DropdownToggler,
  W3DropdownContent,
} from "../../../../components/W3Dropdown";
import { ConnectionTypes, isDeletionTask, filterTasksByTaskType } from "../Utils";
import ITTaskDialog from "./ITTaskDialog";
import ActionFilter from "../ActionFilter";

export default function DelphiConnectionTaskMenu({
  className = "",
  selectedDelphiConnections = [],
  connectionTaskType,
  exportDelphiConnections,
  closeDelphiConnections,
  filterConnections,
  items = [],
}) {
  const taskDialogRef = React.useRef(null);

  const closeableConnections = React.useMemo(() => {
    if (isDeletionTask(connectionTaskType) && selectedDelphiConnections) {
      return selectedDelphiConnections.filter((item) =>
        filterTasksByTaskType(item, connectionTaskType),
      );
    }
    return [];
  }, [connectionTaskType, selectedDelphiConnections]);

  const onExport = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "Delphi";
      let counter = 0;
      if (selectedDelphiConnections && selectedDelphiConnections.length > 0) {
        counter += selectedDelphiConnections.length;
      }
      const isSingular = counter === 1;
      taskDialogRef.current.show(
        true,
        {
          title: `${type}-Zugänge exportieren`,
          text: `
          ${isSingular ? "Der" : "Alle " + counter} ausgewählte ${type}-Zugang${isSingular ? " wird" : " werden"} für die  
          Weiterverarbeitung vorbereitet und als CSV exportiert. Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: true,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (data) => exportDelphiConnections(data),
      );
    },
    [selectedDelphiConnections, exportDelphiConnections, connectionTaskType],
  );

  const onClose = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      let counter = 0;
      if (closeableConnections && closeableConnections.length > 0) {
        counter += closeableConnections.length;
      }
      const isSingular = counter === 1;
      taskDialogRef.current.show(
        true,
        {
          title: `Delphi-Zugangsaufgabe${isSingular ? "" : "n"} schließen`,
          text: `
          ${isSingular ? "Der" : "Alle " + counter} ausgewählte Delphi-${isSingular ? "Zugang wird" : "Zugänge werden"} nun abgeschlossen.  
          Wollen Sie fortfahren?
        `,
          showTaskType: false,
        },
        () => closeDelphiConnections(closeableConnections),
      );
    },
    [closeableConnections, closeDelphiConnections],
  );

  const isDelphiExportable = selectedDelphiConnections && selectedDelphiConnections.length > 0;
  const isCloseable = closeableConnections && closeableConnections.length > 0;

  return (
    <div className={className}>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle pad-rht">
          <ActionFilter
            type="Delphi"
            taskType={connectionTaskType}
            setTaskType={filterConnections}
            itemsToCount={items}
            className="display-inline-block"
          />
        </div>
        <div className="w3-cell w3-cell-middle pad-lft">
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler
              as={PrimaryButton}
              size="small-"
            >{`Optionen`}</W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "280px" }}
            >
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onExport}
                disabled={!isDelphiExportable}
              >
                {`Delphi-Zugänge exportieren (CSV)`}
              </ButtonLink>
              <ButtonLink
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                to={`/wizard/aufgabe/import/${ConnectionTypes.DELPHI_CONNECTION.toLowerCase()}`}
                disabled={false}
              >
                {`Delphi-Zugänge importieren (CSV)`}
              </ButtonLink>
              <a href="#" className="w3-bar-item separator">
                <div className="w3-border-top" style={{ margin: "0 -4px" }} />
              </a>
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onClose}
                disabled={!isCloseable}
              >
                {`Delphi-Zugänge schließen`}
              </ButtonLink>
            </W3DropdownContent>
          </W3Dropdown>
        </div>
      </div>
      <ITTaskDialog ref={taskDialogRef} />
    </div>
  );
}

DelphiConnectionTaskMenu.propTypes = {
  className: PropTypes.string,
  selectedDelphiConnections: PropTypes.array,
  connectionTaskType: PropTypes.string,
  exportDelphiConnections: PropTypes.func.isRequired,
  closeDelphiConnections: PropTypes.func.isRequired,
  filterConnections: PropTypes.func.isRequired,
  items: PropTypes.array,
  history: PropTypes.object,
};
